export const talendEndpoint = process.env.VUE_APP_TALEND_ENDPOINT || '';
export const pimCoreUrl = process.env.VUE_APP_PIMCORE_HOST || '';
export const pimCoreAssetFolderId = parseInt(process.env.VUE_APP_PIMCORE_ASSET_FOLDER || '0', 10);
export const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:1337/api/';

export const folderIds: Record<string, string> = {
  Supplier: process.env.VUE_APP_PIMCORE_FOLDER_SUPPLIER || '',
};

export const graphqlEndpoints = {
  createProvider: `${talendEndpoint}/provider/create`,
  updateProvider: `${talendEndpoint}/provider/update`,
  listings: `${talendEndpoint}/listings`,
  createApplication: `${talendEndpoint}/application/create`,
  processHRApplication: `${talendEndpoint}/applications/process-HR`,
  processHRReworkApplication: `${talendEndpoint}/applications/process-HR-rework`,
  processSupplierApplication: `${talendEndpoint}/applications/process-supplier`,
  processEditApplication: `${talendEndpoint}/applications/process-edit`,
  processCoordinatorApplication: `${talendEndpoint}/applications/process-coordinator`,
  fillApplicationActuals: `${talendEndpoint}/applications/fill-application-actuals`,
  editFactualData: `${talendEndpoint}/applications/factual-data`,
  getAggregatedOperations: `${talendEndpoint}/application/aggregated-operations`,
  getAggregatedApplications: `${talendEndpoint}/application/aggregated-applications-hr`,
};

export const ratesEndpoints = {
  createRatesTable: `${talendEndpoint}/rates`,
  updateRatesTable: `${talendEndpoint}/rates`,
  deleteRatesTable: `${talendEndpoint}/rates`,
  getRatesTables: `${talendEndpoint}/rates`,
};

export const usersApi = {
  gauth: `${apiUrl}users/authenticate-gauth`,
  auth: `${apiUrl}users/authenticate`,
  me: `${apiUrl}users/me`,
  logout: `${apiUrl}users/logout`,
  editInfo: `${apiUrl}users/send-request-edit-info`,
};

export const accountingSheet = {
  calculatedOperations: `${talendEndpoint}/operations/calculate?dateFrom={dateFrom}&dateTo={dateTo}&supplier={supplier}&platformId={platformId}&clientIds={clientIds}`,
  bulkQualityPerformance: `${talendEndpoint}/operations/bulk/quality-performance`,
  toShapeAccountingSheet: `${talendEndpoint}/accounting-sheet`,
  accountingSheetList: `${talendEndpoint}/accounting-sheet/list`,
  accountingSheetSingle: `${talendEndpoint}/accounting-sheet/single`,
  accountingSheetUpdate: `${talendEndpoint}/accounting-sheet/update`,
  downloadFiles: {
    linkAccountingSheetWithoutSignature: `${talendEndpoint}/accounting-sheet/link`,
    linkConstructorForDownload: `${talendEndpoint}/files/download?authorization={authorizationToken}&bucket={bucket}&file={file}`,
  },
  status: {
    processControlling: `${talendEndpoint}/accounting-sheet/status/process-controlling`,
    processAccountant: `${talendEndpoint}/accounting-sheet/status/process-accounting`,
    processAccountantPaymentDone: `${talendEndpoint}/accounting-sheet/status/process-payment`,
    cancel: `${talendEndpoint}/accounting-sheet/status/cancel`,
    recall: `${talendEndpoint}/accounting-sheet/status/recall`,
    sign: `${talendEndpoint}/accounting-sheet/sign`,
    change: `${talendEndpoint}/accounting-sheet/status/change`,
  },
};

export const pretension = {
  create: `${talendEndpoint}/pretension`,
  update: `${talendEndpoint}/pretension/update`,
  list: `${talendEndpoint}/pretension/list`,
  single: `${talendEndpoint}/pretension/single`,
  status: {
    processSigner: `${talendEndpoint}/pretension/status/process-signer`,
    processAccountant: `${talendEndpoint}/pretension/status/process-accounting`,
    cancel: `${talendEndpoint}/pretension/status/cancel`,
    paymentDone: `${talendEndpoint}/pretension/status/process-payment-done`,
  },
};

export const talendCommon = {
  uploadFileToS3: `${talendEndpoint}/files/upload`,
  downloadFileFromS3: `${talendEndpoint}/files/download?authorization={authorizationToken}&bucket={bucket}&file={file}`,
};

export const processSupplier = {
  confirmFact: `${talendEndpoint}/applications/process-supplier-confirm-fact`,
};

export const allowedRoutes = [
  'ApplicationHR',
];

export const gauthOption = {
  clientId: process.env.VUE_APP_GAUTH_CLIENT_ID || '',
  password: process.env.VUE_APP_GAUTH_PASSWORD || null,
  scope: 'profile email',
  prompt: 'select_account',
};

export const report = {
  generateOperationReport: `${talendEndpoint}/report/operation`,
};
